import { SET_TRACKING_SEARCH_ID } from './tracking.types';
export var setTrackingSearchId = function setTrackingSearchId(tracking) {
  return {
    type: SET_TRACKING_SEARCH_ID,
    tracking: tracking
  };
};